import { render, staticRenderFns } from "./investment-level-panel.vue?vue&type=template&id=3a8d6db9&scoped=true&"
import script from "./investment-level-panel.vue?vue&type=script&lang=ts&"
export * from "./investment-level-panel.vue?vue&type=script&lang=ts&"
import style0 from "./investment-level-panel.vue?vue&type=style&index=0&id=3a8d6db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d6db9",
  null
  
)

export default component.exports